import { apiRequest } from "./client";

export const getHealth = () => apiRequest("/api/v1/health");
export const getBotStatus = () => apiRequest("/api/v1/bot/status");
export const getBotStats = () => apiRequest("/api/v1/bot/stats");
export const getBotInfo = () => apiRequest("/api/v1/bot/info");

const STATUS_META_KEYS = new Set(["latency", "guilds", "shards", "users", "commands", "uptime"]);

export const isOkValue = (v) =>
  v === true ||
  (typeof v === "string" && ["online", "operational", "up", "ok", "healthy"].includes(v.toLowerCase()));

export const splitStatus = (data) => {
  const services = Object.entries(data || {}).filter(
    ([key, value]) =>
      key !== "online" &&
      !STATUS_META_KEYS.has(key) &&
      (typeof value === "boolean" || typeof value === "string")
  );
  const servicesOk = services.length > 0 && services.every(([, v]) => isOkValue(v));
  return {
    overall: typeof data?.online === "boolean" ? data.online : servicesOk,
    services,
    latency: typeof data?.latency === "number" ? data.latency : null,
    guilds: typeof data?.guilds === "number" ? data.guilds : null,
    shards: typeof data?.shards === "number" ? data.shards : null,
  };
};
